
import VuePicker from 'vue-pickers'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { getDisplayName, getuserCurrentApp } from '@/utils/cookies.ts'
import { AppModule, DeviceType } from '@/store/modules/app'
import { UserModule } from '@/store/modules/user'
import { CONFIGAPI } from '@/api/config'
import { ConfigModule } from '@/store/modules/config'
import { problemList } from '@/utils/consts'
import { SPYYISISSUESAPI } from '@/api/spyy'

@Component({
  name: 'networkManualWork',
  components: {
    VuePicker
  }
})
export default class AppMain extends Vue {
  @Prop({ default: false }) private editForm!: any; // 编辑表单时用到的表单数据
  private editId = 0;
  private isDisableSubmit = false; // 避免重复触发提交按钮
  private locationOptions = []; // 所在地区options
  private issueTypeOptions = []; // 问题类型options
  // 联动下拉框手机端
  private pickerIssueVisible = false; // 点击所在地区文本框，显示picker联动
  private defaultIssueIndex = [] as number[]; // 默认联动定位，从0开始，0代表第一行
  private NetworkIssueCn = ''; // 移动端：所在地区内容

  private resolve_minutes = 0; // 完成时长

  formData = {
    // tutorName: this.username,
    // issueDate: new Date(),
    location: [] as any,
    describe: '',
    creator: '',
    creator_cn: '',
    accept_user_cn: this.username,
    accept_user: this.userWorkCode,
    create_time: '',
    finish_time: '',
    solution: '',
    issue_type: [] as any
    // problem_attr: "1",
    // is_live_influenced: 0,
  };

  formRules: object = {
    creator: [
      {
        required: true,
        message: '请输入发起人名称',
        trigger: ['blur', 'change']
      }
    ],
    accept_user_cn: [{ required: true }],
    location: [
      { required: true, message: '请选择所在地区', trigger: 'change' }
    ],
    describe: [
      {
        required: true,
        message: '请详细描述您的问题',
        trigger: 'blur',
        min: 1
      }
    ],
    create_time: [{ required: true, message: '请选择日期', trigger: 'change' }],
    finish_time: [{ required: true, message: '请选择日期', trigger: 'change' }],
    solution: [
      { required: true, message: '请输入问题解决方案', trigger: 'change' }
    ],
    issue_type: [{ required: true, message: '请选择问题源' }]
  };

  pickerOptions: object = {
    disabledDate(time: any) {
      return time.getTime() > Date.now()
    }
  };

  get userCurrentApp() {
    return getuserCurrentApp()
  }

  get isEdit() {
    return !!this.editForm
  }

  get problemList() {
    return problemList
  }

  // 标题
  get formTitle() {
    let title = '行政'
    // title += this.ticketType === 2 ? '班主任' : 'LP(学规)'
    title += this.isEdit ? '工单编辑' : '工单录入'
    return title
  }

  get device() {
    return AppModule.device
  }

  get classObj() {
    return {
      mobile: this.device === DeviceType.Mobile
    }
  }

  get username() {
    return getDisplayName()
  }

  get userWorkCode() {
    return UserModule.workcode
  }

  get isMobile() {
    return AppModule.device === DeviceType.Mobile
  }

  // 响应
  @Watch('formData.create_time', { deep: true })
  private watchAccepTime(newVal: string, oldVal: string) {
    if (newVal === null) {
      this.resolve_minutes = 0
      return
    }
    if (this.formData.finish_time) {
      const response_time_tmp = this.formData.finish_time.replace(/-/g, '/')
      const happend_time_tmp = this.formData.create_time.replace(/-/g, '/')
      const response_time = new Date(response_time_tmp).getTime()
      const happend_time = new Date(happend_time_tmp).getTime()
      const minuteDiff = Math.trunc((response_time - happend_time) / 1000 / 60) // 分钟
      const secondsDiff = minuteDiff / 60 // 秒
      if (minuteDiff < 0) {
        this.$message({
          message: '问题响应时间需大于问题发生时间！',
          type: 'error'
        })
        this.resolve_minutes = 0
      } else {
        this.resolve_minutes = secondsDiff
      }
    }
  }

  // 完成
  @Watch('formData.finish_time', { deep: true })
  private watchFinishTime(newVal: string, oldVal: string) {
    if (newVal === null) {
      this.resolve_minutes = 0
      return
    }
    if (this.formData.create_time) {
      const resolve_time_tmp = this.formData.finish_time.replace(/-/g, '/')
      const response_time_tmp = this.formData.create_time.replace(/-/g, '/')
      const resolve_time = new Date(resolve_time_tmp).getTime()
      const response_time = new Date(response_time_tmp).getTime()
      const minuteDiff = Math.trunc((resolve_time - response_time) / 1000 / 60) // 分钟
      const secondsDiff = minuteDiff / 60 // 秒
      if (minuteDiff < 0) {
        this.$message({
          message: '完成时间需大于开始时间！',
          type: 'error'
        })
        this.resolve_minutes = 0
      } else {
        this.resolve_minutes = secondsDiff
      }
    }
  }

  @Watch('locationOptions')
  private watchLocationOptions(newVal: any, oldVal: any) {
    if (this.isEdit) {
      this.handleChangeLocation(this.formData.location)
    }
  }

  mounted() {
    this.getTutorIssueType() // 获取班主任所在地区列表
    this.getIssueType() // 获取问题类型
    // 编辑时location值设置
    if (this.isEdit) {
      this.assignFormdata()
      this.handleChangeLocation(this.formData.location)
    }
  }

  // 用户姓名/工号输入建议
  private querySearchUser(queryString: string, callback: any) {
    CONFIGAPI.getUsersData({
      key: queryString
    })
      .then((res) => {
        if (res.stat === 1) {
          callback(res.data)
        }
      })
      .catch((error) => {
        console.log('发生错误！', error)
      })
  }

  // 选中用户
  private handleSelectCreator(user: any) {
    (this.$refs.tutorForm as any).clearValidate('creator')

    this.formData.creator_cn = user.name
    this.formData.creator = user.workcode
  }

  // 获取问题类型
  private async getIssueType() {
    const options = ConfigModule.issueTypeOptions
    if (options.length <= 0) {
      // 仅首次打开时请求
      const { data } = await CONFIGAPI.getIssuesType({
        app_id: this.userCurrentApp
      })
      const newData: any = []
      // 删掉掉没有基地的地区
      data.map((item: any) => {
        if (item.children && item.children.length !== 0) {
          newData.push(item)
        }
      })
      this.issueTypeOptions = newData
      ConfigModule.setIssueTypeOptions(newData)
    } else {
      this.issueTypeOptions = options
    }
  }

  private formatDateTime(time: any) {
    const dateTime = new Date(time)
    const year = dateTime.getFullYear()
    const month = dateTime.getMonth() + 1
    const date = dateTime.getDate()
    const hour = dateTime.getHours()
    const minute = dateTime.getMinutes()
    return `${year}-${this.addZero(month)}-${this.addZero(date)} ${this.addZero(
      hour
    )}:${this.addZero(minute)}`
  }

  private addZero(v: any) {
    return v < 10 ? '0' + v : v
  }

  private handleChangeLocation(value: any) {
    // console.log('下拉框改变', value)
  }

  // 获取班主任所在地区列表
  private async getTutorIssueType() {
    const { data } = await CONFIGAPI.getLocation({
      app_id: this.userCurrentApp
    })
    let newData: any = []
    // 删掉掉没有基地的地区，移除转接虚拟基地
    data.map((item: any) => {
      if (
        item.children &&
        item.children.length !== 0 &&
        item.label.indexOf('转接') === -1
      ) {
        newData.push(item)
      }
    })
    if (this.classObj.mobile) {
      // 手机端插件数据结构需要用value
      newData = JSON.parse(JSON.stringify(newData).replace(/"id"/g, '"value"'))
    }
    this.locationOptions = newData
    // 移动端：编辑时定位直播间级联的默认位置
    if (this.classObj.mobile && this.isEdit) {
      this.locationOptions.some((parent: any, index1: number) => {
        if (parent.value === this.editForm.location.place_id) {
          parent.children.some((building: any, index2: number) => {
            if (building.value === this.editForm.location.building_id) {
              building.children.some((item: any, index3: number) => {
                if (item.value === this.editForm.location.floor_id) {
                  this.defaultIssueIndex = [index1, index2, index3]
                }
              })
            }
          })
        }
      })
    }
  }

  // 移动端：所在地区联动确认
  confirmChangeIssue(res: any) {
    const issueType: string[] = []
    res.map((item: { label: string }) => {
      issueType.push(item.label)
    })
    this.NetworkIssueCn = issueType.join('/')
    this.formData.location = [
      res[0].value || res[0].id,
      res[1].value || res[1].id,
      res[2] ? res[2].value || res[2].id : ''
    ]
  }

  // 编辑赋值
  assignFormdata() {
    this.editId = this.editForm.id
    const editLocationType: any = [
      this.editForm.location.place_id,
      this.editForm.location.building_id,
      this.editForm.location.floor_id
    ]
    const editIssueType: any = [
      this.editForm.issue_type.pid,
      this.editForm.issue_type.id
    ]
    this.formData = {
      // is_live_influenced: this.editForm.is_live_influenced,
      location: editLocationType,
      describe: this.editForm.describe,
      creator: this.editForm.creator.workcode,
      creator_cn: this.editForm.creator.name,
      accept_user_cn: this.editForm.accept_user.name,
      accept_user: this.editForm.accept_user.workcode,
      create_time: this.editForm.create_time,
      finish_time: this.editForm.finish_time,
      // problem_attr: String(this.editForm.problem_attr),
      solution: this.editForm.solution || '',
      issue_type: editIssueType
    }
    this.NetworkIssueCn =
      this.editForm.location.place +
      '/' +
      this.editForm.location.building +
      '/' +
      this.editForm.location.floor

    if (this.editForm.finish_time && this.editForm.create_time) {
      const accept_time_tmp = this.formData.create_time.replace(/-/g, '/')
      const finish_time_tmp = this.formData.finish_time.replace(/-/g, '/')
      const accept_time = new Date(accept_time_tmp).getTime()
      const finish_time = new Date(finish_time_tmp).getTime()
      const minuteDiff = (finish_time - accept_time) / 1000 / 60 // 分钟
      this.resolve_minutes = Math.trunc(minuteDiff)
      if (finish_time - accept_time < 0) {
        this.$message({
          message: '完成时间需要大于开始时间！',
          type: 'error'
        })
      }
    }
  }

  handleSubmit(formName: string) {
    const resolve_time_tmp = this.formData.finish_time.replace(/-/g, '/')
    const response_time_tmp = this.formData.create_time.replace(/-/g, '/')
    if (
      new Date(resolve_time_tmp).getTime() -
        new Date(response_time_tmp).getTime() <
      0
    ) {
      this.$message({
        message: '问题完成时间需大于问题开始时间！',
        type: 'error'
      })
      return
    }

    const form: any = this.$refs[formName]
    form.validate(async (valid: boolean) => {
      if (valid) {
        this.isDisableSubmit = true
        const action = 'manualAdd'
        await (SPYYISISSUESAPI as any)
          // eslint-disable-next-line no-unexpected-multiline
          [action](
            {
              location: Number(this.formData.location[2].split('_')[1]),
              describe: this.formData.describe,
              creator: this.formData.creator,
              creator_cn: this.formData.creator_cn,
              accept_user: this.formData.accept_user,
              accept_user_cn: this.formData.accept_user_cn,
              create_time: this.formData.create_time,
              finish_time: this.formData.finish_time
                ? this.formData.finish_time
                : null,
              issue_type: this.formData.issue_type[1],
              solution: this.formData.solution
            },
            {
              app_id: this.userCurrentApp
            }
          )
          .then((res: any) => {
            if (res.stat === 1) {
              this.$message.success('提交成功')
              this.handleResetForm(formName)
              this.$router.push({ path: '/home' })
            }
            this.isDisableSubmit = false
          })
          .catch(() => {
            this.isDisableSubmit = false
          })
      } else {
        console.log('error submit!!')
        return false
      }
    })
  }

  handleEditSubmit(formName: string) {
    const finish_time_tmp = this.formData.finish_time.replace(/-/g, '/')
    const create_time_tmp = this.formData.create_time.replace(/-/g, '/')
    if (
      new Date(finish_time_tmp).getTime() -
        new Date(create_time_tmp).getTime() <
      0
    ) {
      this.$message({
        message: '完成时间需大于开始时间！',
        type: 'error'
      })
      return
    }

    const form: any = this.$refs[formName]
    form.validate(async (valid: boolean) => {
      if (valid) {
        this.isDisableSubmit = true
        const action = 'manualEdit'
        await (SPYYISISSUESAPI as any)
          // eslint-disable-next-line no-unexpected-multiline
          [action](
            {
              id: this.editId,
              location: Number(this.formData.location[2].split('_')[1]),
              describe: this.formData.describe,
              // is_live_influenced: this.formData.is_live_influenced,
              creator: this.formData.creator,
              creator_cn: this.formData.creator_cn,
              accept_user: this.formData.accept_user,
              accept_user_cn: this.formData.accept_user_cn,
              create_time: this.formData.create_time,
              finish_time: this.formData.finish_time
                ? this.formData.finish_time
                : null,
              // problem_attr: Number(this.formData.problem_attr),
              issue_type: this.formData.issue_type[1],
              solution: this.formData.solution
            },
            {
              app_id: this.userCurrentApp
            }
          )
          .then((res: any) => {
            if (res.stat === 1) {
              this.$emit('handleSuccess', res)
              this.$emit('handleCloseDialog')
            }
            this.isDisableSubmit = false
          })
          .catch(() => {
            this.isDisableSubmit = false
          })
      } else {
        console.log('error submit!!')
        return false
      }
    })
  }

  handleResetForm(formName: string) {
    this.NetworkIssueCn = ''
    this.defaultIssueIndex = [0, 0, 0]
    const form: any = this.$refs[formName]
    form.resetFields()
    this.formData.location = [0, 0, 0]
  }
}
